import * as React from "react"
import { type Transaction } from "@digits-graphql/frontend/graphql-bearer"
import useRouter from "@digits-shared/hooks/useRouter"
import { useFrontendPathGenerator } from "src/frontend/hooks/useFrontendPathGenerator"
import routes from "src/frontend/routes"

export function useTransactionRowClick() {
  const { history } = useRouter()
  const pathGenerator = useFrontendPathGenerator()

  return React.useCallback(
    (transaction: Transaction) => {
      const detailsRoute = routes.accountingDetailEdit
      const detailsPath = pathGenerator(detailsRoute, {
        transactionId: transaction.factId,
      })

      history.push(detailsPath)
    },
    [history, pathGenerator]
  )
}
